import api from "./axios";

export const getFGStock =
() =>
api.get(
"/fg-stock"
);